<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" :id="offcanvas_id" data-bs-backdrop="static" :aria-labelledby="`${offcanvas_id}_label`">
    <div class="offcanvas-header">
      <button class="btn-back" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" aria-label="Close">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" :id="`${offcanvas_id}_label`">{{ title }}</h5>
    </div>
    <div class="offcanvas-body">
      <p v-html="text"></p>

      <div class="form-floating" v-if="confirmValue">
        <input class="form-control" type="text" id="genericConfirmInput" :placeholder="inputPlaceholder" v-model="typedValue" autocomplete="off" @keyup.enter="doConfirm"/>
        <label for="genericConfirmInput">{{ inputPlaceholder }}</label>
      </div>

      <!-- footer inside body to avoid empty space between body and footer -->
      <div class="offcanvas-footer">
        <button type="button" class="btn" :class="okButtonClass" :disabled="!canConfirm" data-test="btnConfirm" @click="doConfirm">{{ okButton }}</button>
        <button type="button" class="btn" :class="cancelButtonClass" v-show="cancelButton" data-test="btnCancel" @click="doCancel">{{ cancelButton }}</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.offcanvas {
  // width:                                510px !important;
  // padding:                              40px;

  z-index:                              1048;

  .offcanvas-header,
  .offcanvas-body {
    padding:                            0;
  }

  .offcanvas-header {
    display:                            block;
  }

  .offcanvas-title {
    color:                              var(--Brand-Primary, #1B294A);
    font-size:                          38px;
    font-weight:                        300;
    line-height:                        normal;
    margin:                             26px 0;
  }

  .offcanvas-body {
    p,
    li {
      color:                            var(--Brand-Primary, #1B294A);
      font-size:                        var(--font-size-14);
      font-weight:                      300;
      line-height:                      140%; /* 19.6px */
      margin-bottom:                    26px;
    }

    .form-floating {
      margin-bottom:                   26px;
    }
  }

  .offcanvas-footer {
    display:                            flex;
    flex-direction:                     column;
    gap:                                26px;

    .btn {
      font-size:                        var(--font-size-14);
      font-weight:                      700;
      line-height:                      normal;
      letter-spacing:                   4.2px;
      text-align:                       center;
      text-transform:                   uppercase;
      // gap:                              10px;
      // flex:                             1 0 0;
      width:                            100%;
      padding:                          20px;
    }

    .btn-success {
      color:                            var(--Shades-W, #FFF);
      // margin-top:                       26px;
    }
  }
}
</style>

<script>
export default {
  name: 'BaseGenericOffcanvas',
  props: { offcanvas_id: { type: String, required: true } },
  data: () => ({
    title: null,
    text: null,
    okButton: null,
    okButtonClass: null,
    cancelButton: null,
    cancelButtonClass: null,
    confirmValue: null,
    inputPlaceholder: null,
    typedValue: '',
    offcanvas_generic: null,
    onConfirm: null,
  }),
  computed: {
    canConfirm() {
      if (!this.confirmValue)
        return true

      return this.typedValue.trim().toLowerCase() === this.confirmValue.trim().toLowerCase()
    }
  },
  mounted() {
  },
  methods: {
    show(options = {}) {
      this.title = options.title
      this.text = options.text
      this.okButton = options.okButton
      this.okButtonClass = options.okButtonClass
      this.confirmValue = options.confirmValue || null
      this.inputPlaceholder = options.inputPlaceholder || null
      this.typedValue = ''
      this.cancelButton = options.cancelButton || null
      this.cancelButtonClass = options.cancelButtonClass || null
      this.onConfirm = typeof options.onConfirm === 'function' ? options.onConfirm : null

      const el = document.getElementById(this.offcanvas_id)
      this.offcanvas_generic = bootstrap.Offcanvas.getOrCreateInstance(el)
      this.offcanvas_generic.show()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    doConfirm() {
      if (!this.canConfirm)
        return

      this.offcanvas_generic.hide()
      this.offcanvas_generic = null
      if (this.onConfirm) {
        this.onConfirm(this.resolvePromise)
        return
      }
      this.resolvePromise(true)
    },

    doCancel() {
      this.offcanvas_generic.hide()
      this.offcanvas_generic = null
      this.resolvePromise(false)
    },
  }
}
</script>
